module.exports = __webpack_public_path__ + "img/badge_faq.3bec521b.jpg";